import React, { FunctionComponent, useEffect, useState } from 'react';
import { filtersUsersState } from 'utils/states';
import WhiteCard from 'global/atoms/WhiteCard';
import Pagination from 'global/pagination/Pagination';
import Filters from 'global/filters/Filters';
import TranslationsConnection from 'utils/connections/translations';
import Input from 'global/atoms/Input';
import { Cell, Column, HeaderCell } from 'rsuite-table';
import arrow from 'assets/svg/arrow_down_small.svg';
import settings from 'assets/svg/settings.svg';
import List from 'global/table/List';
import { useHistory } from 'react-router-dom';
import Textarea from 'global/atoms/Textarea';
import { useDispatch } from 'react-redux';
import HeaderButtons from 'global/atoms/headerButtons/HeaderButtons';
import ButtonFilters from 'global/atoms/ButtonFilters';
import ButtonAddNew from 'global/atoms/ButtonAddNew';
import Spinner from 'global/atoms/Spinner/Spinner';

interface ITranslationsList {}

const TranslationsList: FunctionComponent<ITranslationsList> = () => {
  const [data, setData] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState<any>({
    locale: '',
    field: '',
    text: '',
    hint: '',
    requestOrder: {
      field: '',
      order: '',
    },
    requestPaginate: {
      page: 1,
      limit: 10,
    },
  });
  const [toggleFilters, setToggleFilters] = useState<boolean>(false);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    TranslationsConnection.getTranslations(filters).then((data) => {
      setLoading(false);
      setData(data.data);
      data.data?.header && dispatch({ type: 'SET_HEADER', payload: data.data.header });
    });
    setFilters((state: any) => ({
      ...state,
      requestPaginate: {
        page: 1,
        limit: state.requestPaginate.limit,
      },
    }));
  }, [filters.requestPaginate.limit]);

  useEffect(() => {
    TranslationsConnection.getTranslations(filters).then((data) => {
      setLoading(false);
      setData(data.data);
      data.data?.header && dispatch({ type: 'SET_HEADER', payload: data.data.header });
    });
  }, [filters.requestPaginate.page, filters.requestOrder]);

  const handleToggleSort = (event: any) => {
      if (filters.requestOrder.field === event.currentTarget.dataset.field) {
        setFilters({
          ...filters,
          requestOrder: {
            field: filters.requestOrder.field,
            order: filters.requestOrder.order === 'asc' ? 'desc' : 'asc',
          },
        });
      } else {
        setFilters({
          ...filters,
          requestOrder: {
            field: event.currentTarget.dataset.field,
            order: 'asc',
          },
        });
      }
    },
    handleToggleFilters = () => setToggleFilters((state: boolean) => !state),
    handleSubmitFilters = (event: any) => {
      event.preventDefault();

      TranslationsConnection.getTranslations({
        ...filters,
        requestPaginate: { page: 1, limit: filters.requestPaginate.limit },
      }).then((data) => {
        setToggleFilters(false);
        setData(data.data);
        data.data?.header && dispatch({ type: 'SET_HEADER', payload: data.data.header });
        setFilters((state: any) => ({
          ...state,
          requestPaginate: { page: 1, limit: state.requestPaginate.limit },
        }));
      });
    },
    handleClearFilters = () =>
      setFilters((state: any) => ({
        ...state,
        ...filtersUsersState,
      })),
    handleEdit = (event: any) => {
      history.push(`/superadmin/translations/${event.currentTarget.dataset.id}/edit`);
    },
    handleRowClick = (data: any) => {
      history.push(`/superadmin/translations/${data.id}/edit`);
    };

  if (loading) return <Spinner />;
  if (data === null) return null;

  return (
    <>
      <HeaderButtons>
        <ButtonFilters onClick={handleToggleFilters} />
        <ButtonAddNew />
      </HeaderButtons>
      <WhiteCard mobileTransparent={true} padding={false}>
        <List data={data.data} count={data.data.length} rowClick={handleRowClick}>
          <Column flexGrow={1} align="left">
            <HeaderCell depth={0} width={0}>
              <span
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                onClick={handleToggleSort}
                data-field={'name'}
              >
                Podpowiedź
                {filters.requestOrder.field === 'name' &&
                  (filters.requestOrder.order === 'asc' ? (
                    <img src={arrow} alt={'sort'} />
                  ) : (
                    <img src={arrow} alt={'sort'} style={{ transform: 'rotate(180deg)' }} />
                  ))}
              </span>
            </HeaderCell>
            <Cell width={100} depth={0} dataKey="hint" />
          </Column>
          <Column verticalAlign={'middle'} align="right" fixed={'right'}>
            <HeaderCell depth={0} width={0}>
              Akcje
            </HeaderCell>
            <Cell depth={0} width={0}>
              {(rowData) => (
                <img
                  src={settings}
                  style={{ cursor: 'pointer' }}
                  alt={'Idź do'}
                  data-id={rowData.id}
                  onClick={handleEdit}
                />
              )}
            </Cell>
          </Column>
        </List>
      </WhiteCard>
      <Pagination
        count={data.count}
        page={filters.requestPaginate.page.toString()}
        limit={filters.requestPaginate.limit.toString()}
        setState={setFilters}
      />
      <Filters
        toggleFilters={toggleFilters}
        handleToggleFilters={handleToggleFilters}
        handleSubmit={handleSubmitFilters}
        handleClear={handleClearFilters}
      >
        <Input
          value={filters.name}
          placeholder={'Język (kod)'}
          name={'locale'}
          type={'text'}
          setState={setFilters}
          state={filters}
        />
        <Input
          value={filters.name}
          placeholder={'Pole'}
          name={'field'}
          type={'text'}
          setState={setFilters}
          state={filters}
        />
        <Textarea value={filters.name} placeholder={'Treść'} name={'text'} setState={setFilters} state={filters} />
        <Textarea value={filters.name} placeholder={'Podpowiedź'} name={'hint'} setState={setFilters} state={filters} />
      </Filters>
    </>
  );
};

export default TranslationsList;
